import React from 'react'
import Checkbox from '@mui/material/Checkbox';
import styled from 'styled-components';
import theme from 'config/theme';

const StyledCheckbox = styled(Checkbox)`
    {
        &.Mui-checked {
            svg {
                color: #004C6A;
                width: 20px;
                height: 20px;
               
            }
        }   
        svg {
            color: #333333;
            width: 1em;
                height: 1em;
                font-size: 1.2857142857142856rem;
        }
    }
`

const TableCheckbox = (props) => {
    return <StyledCheckbox {...props} color="default" checkedcolor={theme.palette.secondary.main}/>
}

export default TableCheckbox;